import { render, staticRenderFns } from "./ExaminationFinding.vue?vue&type=template&id=64c86458&scoped=true"
import script from "./ExaminationFinding.vue?vue&type=script&lang=js"
export * from "./ExaminationFinding.vue?vue&type=script&lang=js"
import style0 from "./ExaminationFinding.vue?vue&type=style&index=0&id=64c86458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c86458",
  null
  
)

export default component.exports